import React from 'react';
import {
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Toolbar from 'src/layouts/DashboardLayout/Toolbar';
import Notifications from './Notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    padding: theme.spacing(3),
    paddingTop: 0
  }
}));

const SettingsView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Settings"
    >
      <Toolbar />
      <Container maxWidth="lg">
        <Notifications />
      </Container>
    </Page>
  );
};

export default SettingsView;
